import React from 'react';
const noMore = ['No more rebuilding every class and practice session from scratch.', 'No more hours searching scattered videos, forums and notes.', 'No more explaining technique, balance and spirits with words alone.', 'No more students memorizing recipes without understanding why.', 'No more technique, garnish and service drills without visual material.', 'No more repeating the same corrections every week.', 'No more assessing without clear criteria.', 'No more losing time you could spend actually teaching.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#1F4D3A] relative overflow-hidden" data-id="element-125" data-mp="vuru6opk39go">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-126" data-mp="vwuj15ez2wjt">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-127" data-mp="qwzs51v766yr">
          Next Month You Can Still Be Searching for Bartending Training Material...
          <br data-id="element-128" data-mp="zxo84245ihea" />
          <span className="text-[#E0C27A]" data-id="element-129" data-mp="zxxwxmdgmiie">
            Or You Can Have a Complete Visual Training System Ready for Your Next Class.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-[#E0C27A]/60" data-id="element-130" data-mp="2h2y5n518c3qr">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-131" data-mp="2m571c95hljwk">
              <span className="text-[#9C7726] mt-0.5" aria-hidden="true" data-id="element-132" data-mp="2r2p0j7tpckrd">
                ▸
              </span>
              <span className="text-slate-700" data-id="element-133" data-mp="2v38ww96gbkcg">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-134" data-mp="300soeas5ttmc">
          BARTENDING &amp; MIXOLOGY INSTRUCTOR ATLAS doesn&apos;t replace your experience behind the bar, an
          official bartending certification or your local alcohol service laws.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-135" data-mp="3esjbtkydi19i">
          It supports your teaching with a structured visual system designed to give you more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-[#E0C27A]" data-id="element-136" data-mp="1jocz6h9iv5y4">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}